import React from 'react';  
import { connect } from 'react-redux'
import { ACT_SELECTPERIOD } from './actions.js';
import { DayPickerRangeController } from 'react-dates';
import Badge from 'react-bootstrap/Badge'
import Row from 'react-bootstrap/Row'
import QuickPeriodSelector from './QuickPeriodSelector'
import moment from 'moment';  

//import 'react-dates/lib/css/_datepicker.css';
import './css/_datepicker.css';
import './css/PeriodSelector.css';





class PeriodSelector extends React.Component {  

	constructor(props) {
		super(props)
		this.state={focusedInput:"endDate"}	
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
		
	}
	
	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	updateWindowDimensions() {
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	}

	/*showLegend() {
		return (
			<Modal.Dialog>
				<Modal.Header closeButton>
					<Modal.Title>Calendar Legenda</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<p>Modal body text goes here.</p>
				</Modal.Body>

				
			</Modal.Dialog>
			)
	}*/
	
	render() {  

		if (isNaN(this.state.width)) return ""
		let numMonths = Math.floor((this.state.width-22) / 300)
		if (isNaN(numMonths) ) numMonths=1
		if (numMonths === 0) numMonths = 1

		return (
			<div style={this.props.disabled ? { pointerEvents: "none", opacity: "0.3" } : { }}>
			{/*<Container style={{ padding: "0px", margin:"0px" }} >*/ }
				<Row className="justify-content-center" style={{ padding: "0px", margin: "0px" }} >
					<DayPickerRangeController  hideKeyboardShortcutsPanel={true} keepOpenOnDateSelect={true} firstDayOfWeek={1}
						startDate={this.props.startDate} endDate={this.props.endDate}
						numberOfMonths={numMonths}
						onDatesChange={({ startDate, endDate }) => { this.props.setPeriod(startDate, endDate); if (endDate !== null) { this.setState({ focusedInput: "startDate" }) } }}
						focusedInput={this.state.focusedInput}
						onFocusChange={focusedInput => { this.setState({ focusedInput }) }}
						renderDayContents={(day, b) => this.renderDay(day, b)}
						initialVisibleMonth={() => { return moment().add(1 - numMonths, "M") }}
						minimumNights={0}
						isOutsideRange={(day) => (day.isBefore(this.props.startLogs) || day.isAfter(this.props.endLogs))}
						
						/>
					
				</Row>
				< Row className="justify-content-center" style={{ padding:"0px", margin: "1px" }}>
					<QuickPeriodSelector setPeriod={(start, end) => this.props.setPeriod(start, end)} />
				</Row>

			</div>
			);  
	}  

	
	
	renderDay(day, arg2)
	{
		var variant = ""
		let thisday = moment(day).format("DD/MM/YYYY")
		let duration = this.props.durations[thisday]
		let distance = this.props.distances[thisday]
		let isIll = this.props.illnessDays[thisday]
		let isHoliday = this.props.holidays[thisday]
		let isIllOrHoliday = this.props.illholidays[thisday]
		let workRegime = this.props.workRegimes[thisday]
		if (workRegime === undefined) workRegime = 0;

		//console.log("Workregime for day "+ thisday +" is "+workRegime)
		//if (isIllOrHoliday) console.log("ill or holiday on " + thisday)
		let dayToDebug=""
		//console.log("Rendering DAY:"+thisday)
		if (dayToDebug === thisday) {
			console.log("checking against startdate:" + moment(this.props.startLogs).format("DD/MM/YYYY hh:mm:ss"))
			console.log("checking against enddate:" + moment(this.props.endLogs).format("DD/MM/YYYY hh:mm:ss"))
		}
		if (day.isBefore(this.props.startLogs) || day.isAfter(this.props.endLogs)) {
			//older logging which is not retrieved
			if (dayToDebug===thisday) console.log("Older logging")
			return <div>{day.date()}</div>
		}
		else if (day.day()!==6 && day.day()!==0)
		{
			if (dayToDebug === thisday) console.log("is weekday")
			if (day.startOf('day').isSameOrBefore(moment()))
			{
				//console.log("rendering for day:"+moment(day).format("DD/MM/YYYY"))
				if (dayToDebug === thisday) console.log("is in the past")
				
				if (duration > workRegime)
				{
					variant="primary"
				}
				else if (duration === workRegime)
				{
					if (dayToDebug === thisday) console.log("LOG OK")
					variant = "success"
				}
				else if (duration>0)
				{
					variant = "warning"
				}
				else
				{
					if (dayToDebug === thisday) console.log("NO LOGS")
					variant = "danger"
				}
			}
			else{
				//later than now
				if (dayToDebug === thisday) console.log("is in the future")
				if (duration > workRegime) {
					if (dayToDebug === thisday) console.log("worked too much")
					variant = "primary"
				}
				else if (duration === workRegime) {
					if (dayToDebug === thisday) console.log("worked just enough")
					variant = "success"
				}
				else if (duration > 0) {
					if (dayToDebug === thisday) console.log("worked too little")
					variant = "warning"
				}
				else {
					if (dayToDebug === thisday) console.log("Did not work yet")
                }
				
			}
		}
		else
		{
			//weekend overuren
			if (duration>0)
			{
				variant = "primary"
			}
		}
		
		/*var distanceBadge = distance === true ? <sub><sub style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant="primary">&nbsp;</Badge></sub></sub> : undefined
		var illnessBadge = isIll === true ? <sub><sub style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant="danger">&nbsp;</Badge></sub></sub> : undefined
		var holidayBadge = isHoliday === true ? <sub><sup style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant="warning">&nbsp;</Badge></sup></sub> : undefined*/
		var distanceBadge = <sub><sub style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={distance === true ? "primary" :undefined}>&nbsp;</Badge></sub></sub> 
		var illnessBadge = <sub><sub style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={isIll === true ? "danger" : undefined}>&nbsp;</Badge></sub></sub>
		var holidayBadge = <sub><sup style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={isHoliday === true ? "warning" : undefined}>&nbsp;</Badge></sup></sub>
		var illholidayBadge = <sub><sup style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={isIllOrHoliday === true ? "secondary" : undefined}>&nbsp;</Badge></sup></sub>
		return (
				<>
				<Badge variant={variant} >{day.date()}</Badge><span style={{ position: "absolute" }}>{isIllOrHoliday && illholidayBadge}{holidayBadge}{illnessBadge}{distanceBadge}</span>
					</>
			)
	}
    
}  

function mapDispatchToProps(dispatch) {
    return {
        setPeriod: (startDate, endDate) => { dispatch({ type: ACT_SELECTPERIOD, startDate, endDate })}
    }

}

function mapStateToProps(state) {
	//console.log("projectstate:" + state.projects.holidayPrjs)
	var durations = {}
	var distances = {}
	var holidays = {}
	var illnessDays = {}
	var illholidays = {}
	var workRegimes = {}

	//console.log(state.logging.workRegimes)

	state.logging.lstLoggings.forEach(log=>{
		let date = moment(log.startDate).format("DD/MM/YYYY");
		if (durations[date] === undefined) durations[date] = 0
		durations[date] = (durations[date] * 10000 + Number(log.duration) * 10000) / 10000
		if (log.distance > 0) distances[date] = true
		/*
		if (log.isHoliday > 0) holidays[date] = true
		if (log.isIllness > 0) illnessDays[date] = true*/
		if (state.projects.holidayPrjs && state.projects.illnessPrjs) {
			var holiday = state.projects.holidayPrjs.includes(log.projectId);
			var ill = state.projects.illnessPrjs.includes(log.projectId)
			if (holiday && ill) {
				//console.log("log for ill and holiday detected on"+date)
				illholidays[date] = true
			}
			else if (holiday) holidays[date] = true
			else if (ill) illnessDays[date] = true
		}

		if (workRegimes[date] === undefined) {
			//console.log(state.logging.workRegimes)
		
			state.logging.workRegimes.forEach(regime => {
				//let startDate = moment(regime.start).format("DD/MM/YYYY")
				//let endDate = moment(regime.end).format("DD/MM/YYYY")
				
				if (moment(log.startDate).isBetween(regime.start, regime.end)) {
					workRegimes[date] = regime.hoursPerDay / 8;
					//console.log("working regime for " + date + " is:" + regime.hoursPerDay+" or "+workRegimes[date])
                }
			})
		}
		if (workRegimes[date] === undefined) {
			//standard 8 hours per day
			workRegimes[date] = 1;
		}
		
	})
	var startDate = state.period.startDate===null?null:moment(state.period.startDate)
	var endDate = state.period.endDate===null?null:moment(state.period.endDate)
	return { disabled: state.app.edit, lstLoggings: state.logging.lstLoggings, workRegimes, durations, distances, holidays, illnessDays, illholidays, startDate, endDate, startLogs:state.period.startLogs, endLogs:state.period.endLogs}
}
  
export default connect(mapStateToProps,mapDispatchToProps)(PeriodSelector);  